import { favoriteConstants } from '../_constants';

const initialState = {
  favoriteCopyport: null,
  currentColumns: [],
  defaultColumns: [
    'charts', 
    'riskLevel',
    'nav',
    'morningStarRating',
    'fundFlow',
    'performance'
  ],
  tableColumns: [
    {
      header: 'ชื่อกองทุน',
      sortKey: 'fundCode',
      section: 'main'
    },
    {
      header: 'Chart',
      sortKey: 'charts',
      section: 'other'
    },
    {
      header: 'ความเสี่ยง',
      sortKey: 'riskLevel',
      section: 'other'
    },
    {
      header: 'Rating',
      sortKey: 'morningStarRating',
      section: 'other'
    },
    {
      header: 'NAV',
      sortKey: 'nav',
      section: 'other'
    },
    {
      header: 'เงินเข้าออก',
      sortKey: 'fundFlow',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน',
      sortKey: 'performance',
      section: 'other'
    }
  ],
  favoriteFunds: {
    isFetching: false,
    funds: [],
    data: [],
    errorMessage: null
  },
  navFunds: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  queries: {
    returnDateType: '1Y',
    navDateType: '1Y',
    sortBy: null,
    sortType: 'd'
  },
  colors: ['g-bg-red', 'g-bg-purple', 'g-bg-green', 'g-bg-blue', 'g-bg-pink', 'g-bg-cyan', 'g-bg-orange', 'g-bg-teal']
};

const favoriteReducer = (state = initialState, action) => {
  switch (action.type) {
    case favoriteConstants.UPDATE_LOCAL_FAVORITE_FUNDS:
      const {type, fundId} = action.payload;
      return {
        ...state,
        favoriteFunds: {
          ...state.favoriteFunds,
          funds: type === 'add' && !state.favoriteFunds.funds.includes(fundId) 
            ? [...state.favoriteFunds.funds, fundId]
            : type === 'delete'
              ? state.favoriteFunds.funds.filter(x => x !== fundId)
              : state.favoriteFunds.funds,
          data: type === 'delete' && state.favoriteFunds.funds.includes(fundId)
            ? state.favoriteFunds.data.filter(x => x.fundId !== fundId)
            : state.favoriteFunds.data
        }
      };
    case favoriteConstants.FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_START:
      return {
        ...state,
        navFunds: {
          ...state.navFunds,
          isFetching: true
        }
      };
    case favoriteConstants.FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        navFunds: {
          ...state.navFunds,
          isFetching: false,
          data: action.payload ?? [],
          errorMessage: null
        }
      };
    case favoriteConstants.FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        navFunds: {
          ...state.navFunds,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    case favoriteConstants.FETCH_FAVORITE_FUNDS_BY_ACCOUNT_START:
      return {
        ...state,
        favoriteFunds: {
          ...state.favoriteFunds,
          isFetching: true
        }
      };
    case favoriteConstants.FETCH_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        favoriteFunds: {
          ...state.favoriteFunds,
          isFetching: false,
          funds: action.payload?.map(fund => fund.fundId) ?? [],
          data: action.payload ?? [],
          errorMessage: null
        }
      };
    case favoriteConstants.FETCH_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        favoriteFunds: {
          ...state.favoriteFunds,
          isFetching: false,
          funds: [],
          data: [],
          errorMessage: action.payload
        }
      };
    case favoriteConstants.FETCH_FAVORITE_COPYPORT_START:
      return {
        ...state,
        isFetching: true
      };
    case favoriteConstants.FETCH_FAVORITE_COPYPORT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        favoriteCopyport: action.payload
      };
    case favoriteConstants.FETCH_FAVORITE_COPYPORT_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload
      };
    case favoriteConstants.UPDATE_FAVORITE_FUNDS_TABLE_COLUMNS:
      return {
        ...state,
        currentColumns: action.payload ?? [] 
      };
    case favoriteConstants.UPDATE_FAVORITE_FUNDS_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach(attribute => {
        let value = action.payload[`${attribute}`];
        switch (attribute) {
          case 'sortBy': {
            if (value === 'nav' || value === 'riskLevel') {
              updateAttribute['sortType'] =  state.queries.sortBy === value && state.queries.sortType !== 'd' ? 'd' : 'a'
            } else {
              updateAttribute['sortType'] =  state.queries.sortBy === value && value && state.queries.sortType !== 'a' ? 'a' : 'd'
            }
            updateAttribute['sortBy'] = value;
            break;
          };
          default: updateAttribute[attribute] = value; 
            break;
        };
      })
      
      return {
        ...state,
        queries: {
          ...state.queries,
          ...updateAttribute
        }
      }
    }
    default:
      return state;
  }
};

export default favoriteReducer;
